module.exports = __webpack_public_path__ + "img/fankui_banner_en.929d31c8.jpg";